import fastdom from "fastdom"
 import jQuery from 'jquery'; // TO DO GET RID OF JQUERY
import { mediaOrientation } from "./mediaorientation";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
  
export function domReady(fn) {
  if (document.readyState !== 'loading') {
    fn()
    return
  }
  document.addEventListener('DOMContentLoaded', fn)
}


export function detectTouch() {
  var $ = $ || jQuery; // svs addition added based on Tom's fix

  // console.log("detectTouch();")

  //https://medium.com/@david.gilbertson/the-only-way-to-detect-touch-with-javascript-7791a3346685
  // test this on IE - read the comments in the article RE issues
  //https://gist.github.com/adbario/4e33b07d618d499cd81eb691c746b47e#file-jquery-touch-detect-js
  //https://patrickhlauke.github.io/touch/tests/touch-feature-detect.html
  //https://stackoverflow.com/questions/21054126/how-to-detect-if-a-device-has-mouse-support
  //https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
  //http://www.stucox.com/blog/you-cant-detect-a-touchscreen/

  if ("ontouchstart" in window) {

    // console.log("user can touch");
    $("body").removeClass('is-not-touch');
    $("body").addClass('is-touch');
    // run("touch");

    //TODO REW)EW THIS - i thheory this deletes hover states for touch devices
    //APPROPRIATE TO USE?

    //https://stackoverflow.com/questions/23885255/how-to-remove-ignore-hover-css-style-on-touch-devices
    try { // prevent exception on browsers not supporting DOM styleSheets properly
      for (var si in document.styleSheets) {
        var styleSheet = document.styleSheets[si];
        if (!styleSheet.rules) continue;

        for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
          if (!styleSheet.rules[ri].selectorText) continue;

          if (styleSheet.rules[ri].selectorText.match(':hover')) {
            styleSheet.deleteRule(ri);
          }
        }
      }
    } catch (ex) {}

  } else {


    //console.log("user can use their mouse");
    $("body").removeClass('is-touch');
    $("body").addClass('is-not-touch');
    //  run("mouse");
  } // if ("ontouchstart" in window)
  //  console.log("touch" +touch+"value")

}; //detectTouch

export function orientation() {

  var $ = $ || jQuery; // svs addition added based on Tom's fix

  // console.log("hello orientation function")

  function checkOrientation() {

    // console.log("checkOrientation()")
    var winwidth = $(window).width(); // should be inner weidth
    var winheight = $(window).height(); // inner height
    // var isHorizontal;

    if (winwidth > winheight) {
      /* horizontal orientation */
      $("body").addClass('is-horizontal');
      $("body").removeClass('is-vertical');
      // orientationValue = "horizontal";

    } else {
      /* vertical orientation */
      $("body").removeClass('is-horizontal');
      $("body").addClass('is-vertical');
      // orientationValue = "vertical";

    } //else

  }
  checkOrientation(); // run initial
  // check on resize;
  window.addEventListener('resize', checkOrientation);

}


export function objectOrientation(object) {

  // var $ = $ || jQuery; // svs addition added based on Tom's fix

  console.log("hello Object:",object," orientation function")

  function checkOrientation() {

    // console.log("checkOrientation()")
    var objectwidth = $(object).width(); // should be inner weidth
    var objectheight = $(object).height(); // inner height
    // var isHorizontal;

    if (objectwidth > objectheight) {
      /* horizontal orientation */
      $(object).addClass('is-horizontal');
      $(object).removeClass('is-vertical');
      // orientationValue = "horizontal";

    } else {
      /* vertical orientation */
      $(object).removeClass('is-horizontal');
      $(object).addClass('is-vertical');
      // orientationValue = "vertical";

    } //else

  }
  checkOrientation(); // run initial
  // check on resize;
  window.addEventListener('resize', checkOrientation);

}

// TODO - remove scrolling dependencies - js librabries

export function windowHeightVar() {

  // console.log("windowHeightVAr");

  var windowWidth = window.innerWidth;

  // var documentHeight = document.body.clientHeight;
  // var width = window.innerWidth
  // || document.documentElement.clientWidth
  // || document.body.clientWidth;

  // var height = window.innerHeight
  // || document.documentElement.clientHeight
  // || document.body.clientHeight;
  //https://stackoverflow.com/questions/3437786/get-the-size-of-the-screen-current-web-page-and-browser-window

  // https://dev.to/frehner/css-vh-dvh-lvh-svh-and-vw-units-27k4

  window.addEventListener('resize', function () {
    var newWidth = -1;

    fastdom.measure(function () {
      newWidth = window.innerWidth;
    });

    fastdom.mutate(function () {
      if (newWidth === windowWidth) {
        return;
      }
      // this ensure the resizing event is only fired if the width has actually changed
      // this means on mobile things will stay the  

      // windowWidth = newWidth;
      windowHeightValues();
      // //used for full height content; such as navs
      // document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
      // // review if this is a good value obn mobile to use
      // document.documentElement.style.setProperty('--document-height', document.documentElement.clientHeight + 'px');


      // // review these - and implement where need; for the card heights maybe?
      // //used for focused content; such as slider content; wip; i.e "download wrap", flckity slides (to be impleented)
      // //60%
      // document.documentElement.style.setProperty('--content-height', (window.innerHeight * 0.6) + 'px');

      // if (headerSection) {
      //   document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
      // }
    });
  });
  // intitial values set:
  windowHeightValues();




  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', () => {
        console.log('Viewport height changed:', window.visualViewport.height);
        document.documentElement.style.setProperty('--visual-viewport-height', window.visualViewport.height + 'px');

      });

      // initial value set
      document.documentElement.style.setProperty('--visual-viewport-height', window.visualViewport.height + 'px');
  }





}


export function windowHeightValues() {

 
  //used for full height content; such as navs
  //  document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
  // review if this is a good value obn mobile to use
  // try changing to a more constant value

  //windowheight is the height of the viewport
  document.documentElement.style.setProperty('--window-height', document.documentElement.clientHeight + 'px');

  // headerHeight();
  // review this for admin // only server up if not admin
  if (document.querySelector("#header")) { //
    document.documentElement.style.setProperty('--header-height', document.querySelector("#header").clientHeight + 'px');
  }




}

// export function imageryLoaded($container) {
//   // TODO - review this  + timeout options used

//   var $ = $ || jQuery; // svs addition added based on Tom's fix

//   console.log("imageryLoaded($container) - We're not using this  - Implement and review!", $container);

//   // imagesloaded
//   // // this images loaded needs investigating -  removed for now
//   // just adding the loading class to ensure the barba continues
//   $("body").addClass('images-loaded');

//   // $container.imagesLoaded(function () {

//   //     console.log("$container.imagesLoaded  in helpers.js")

//   //   // function waitloading() {

//   //     // $("body").addClass('loaded'); was this- bbut change to:
//   //     //reivew as it might cause issues
//   //     $("body").addClass('images-loaded'); 

//   //   // }; //waitloading()

//   //   // setTimeout(waitloading, 0);

//   // }); //imagesloaded

//   // console.log("end of imageryLoaded($container) - WERE not using this atm - investigate");

// }; //imageryLoaded



/// gsap tl functions



export function onEnterFunction(container, item, applyClass) {
  console.log("onEnterFunction", item);
  // item.classList.add("--narrative-tl-active");
  // container.classList.add("--narrative-tl-active");

  item.classList.add(applyClass);
  container.classList.add(applyClass);

}

export function onLeaveFunction(container, item, applyClass) {
  console.log("onLeaveFunction", item);
  // item.classList.remove("--narrative-tl-active");
  // container.classList.remove("--narrative-tl-active");
  item.classList.remove(applyClass);
  container.classList.remove(applyClass);
}

export function onEnterBackFunction(container, item, applyClass) {
  console.log("onEnterBackFunction", item);
  // item.classList.add("--narrative-tl-active");
  // container.classList.add("--narrative-tl-active");
  item.classList.add(applyClass);
  container.classList.add(applyClass);
}

export function onLeaveBackFunction(container, item, applyClass) {
  console.log("onLeaveBackFunction", item);
  // item.classList.remove("--narrative-tl-active");
  // container.classList.remove("--narrative-tl-active");
  item.classList.remove(applyClass);
  container.classList.remove(applyClass);
}


// Get all siblings above the active item
export function getSiblingsAbove(activeItem) {
  const siblingsAbove = [];
  let sibling = activeItem.previousElementSibling;
  while (sibling) {
    siblingsAbove.push(sibling);
    sibling = sibling.previousElementSibling;
  }
  return siblingsAbove;
}

// Get all siblings below the active item
export function getSiblingsBelow(activeItem) {
  const siblingsBelow = [];
  let sibling = activeItem.nextElementSibling;
  while (sibling) {
    siblingsBelow.push(sibling);
    sibling = sibling.nextElementSibling;
  }
  return siblingsBelow;
}


//remove class by substring
export function removeClassBySubstring(element, substring) {
  var regex = new RegExp('\\b' + substring + '\\b', 'g'); // Word boundary regex
  var classes = element.className.split(/\s+/); // Split classes by whitespace
  var index = classes.findIndex(cls => regex.test(cls)); // Find index of matching class

  if (index !== -1) {
    classes.splice(index, 1); // Remove the matching class
    element.className = classes.join(' '); // Update the element's class list
    return true; // Class was found and removed
  }
  return false; // Class was not found
}

//scroll to use for reference link scrolling
export function scrollToSection(sectionId, container) {
  // container// is barba container - reive if it should be docuymebnt? - w hich is what it was
  console.log("sectionId", sectionId); // needs to be a string - no #
  // console.log("container", container);

  //  id has this appended in front inline_ref_

  //  let id = "inline_ref_"+sectionId+"";
  // console.log("id", id);

  const element = document.getElementById(sectionId);
  // const offset = document.querySelector('.header').offsetHeight;

  const headerHeight = document.getElementById('header').offsetHeight;
  const navHeight = document.querySelector('.single__nav').offsetHeight;
  const headerSectionHeight = document.querySelector('.single__header').offsetHeight;

  // Calculate total offset
  const totalOffset = headerHeight + navHeight + headerSectionHeight;

  // TODO - it appears taht this is the correct values for scroling; based on
  // https://saxoncbe.local/resources/is-offsite-construction-the-answer/
  console.log("headerHeight", headerHeight);
  console.log("navHeight", navHeight);
  console.log("headerSectionHeight", headerSectionHeight);

  console.log("totalOffset", totalOffset);
  // items to cater for:
  // #id="header"
  // single__nav
  // single__header

  // console.log("element",element);



  // if (element) {
  //     element.scrollIntoView({ behavior: 'smooth' });
  //     //ensure to apply offset based on inline link or referece link - consider the contrair offest values requries
  // }


  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    // const offsetPosition = elementPosition - totalOffset;
    // the value should be the top of the element + the offset

    const offsetPosition = elementPosition - totalOffset;

    console.log("elementPosition", elementPosition);
    console.log("offsetPosition", offsetPosition);

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });


    // I ashould add an active claass that just hilight where people have scroll to - then remove it after a few secondss 
    element.classList.add('is-active');
    setTimeout(function () {
      element.classList.remove('is-active');
    }, 2000);
  }




}

export function pad(str, max) {
  str = str.toString();
  return str.length < max ? pad("0" + str, max) : str;
}

// Function to handle media  - in flickity
export function runMediaOrientation(imageSlides, slideshow) {
  console.log("runMediaOrientation", imageSlides, slideshow);

  imageSlides.forEach(function (slide) {
    var thisimagewidth,
      thisimageheight;
    mediaOrientation(slide, thisimagewidth, thisimageheight);
  });
}

// Function to set slideshow status - in flickity
export function setStatus(flkty, counter) {
  if (flkty.slides) {
    var total = pad(flkty.slides.length, 3);
    counter.querySelector('.counter__total').textContent = total;
    updateStatus(flkty, counter);
  }
}

// Function to update slideshow status -  in flickity
export function updateStatus(flkty, counter) {
  var slideNumber = pad(flkty.selectedIndex + 1, 3);
  counter.querySelector('.counter__current').textContent = slideNumber;
}


// trigger a click/ touch event

export function triggerMovement(x = 1, y = 0) {

  console.log("triggerMovement", x, y);

  //This destroys the scroll to on home - because it looks for om event (i.e touch)
  // Remove this fucntion for now - We probably also don't need it; as we got rid fo the proximity thing..
  
  
  // Create and dispatch a mousemove event
  const mouseEvent = new MouseEvent('mousemove', {
      bubbles: true,
      cancelable: true,
      view: window,
      clientX: x,
      clientY: y
  });
  document.dispatchEvent(mouseEvent);

  // Create a touch object
  const touch = new Touch({
      identifier: Date.now(),
      target: document,
      clientX: x,
      clientY: y,
      pageX: x,
      pageY: y,
      screenX: x,
      screenY: y
  });

  // Create and dispatch a touchmove event
  const touchEvent = new TouchEvent('touchmove', {
      bubbles: true,
      cancelable: true,
      touches: [touch],
      targetTouches: [],
      changedTouches: [touch]
  });
  document.dispatchEvent(touchEvent);
}

export function activateRelated(relatedContent) {
  gsap.registerPlugin(ScrollTrigger);

  var relatedContentTitle = relatedContent.querySelector('.panel__header-title div.dm-serif-display-regular'),
    currentText = relatedContentTitle.textContent, // current would be More Resources:
    updatedText = "Resources";

  // console.log("currentText", currentText);

  let tlSingleRelated = gsap.timeline({
    scrollTrigger: {
      trigger: relatedContent, // Use the object directly
      start: "bottom bottom", // this means it never really reaches the end - but when I go back up; classes are removed anyway
      end: "top top", 
      scrub: true, // Smooth scrolling animation
      // markers: false,//Debug markers (remove in production)
      onEnter: () => {
        // console.log("relatedContent entered view");
        relatedContent.classList.add("active");
        relatedContentTitle.textContent = updatedText; // Assign new text
        gsap.to(relatedContentTitle, {
          color: "#484AD8"
           }, "0")
      },
      onLeave: () => {
        // console.log("relatedContent left view");
        relatedContent.classList.remove("active");
        relatedContentTitle.textContent = currentText; // Restore original text
 
        gsap.to(relatedContentTitle, {
        color: "black"
         }, "0")

      },
      onEnterBack: () => {
        // console.log("relatedContent re-entered view");
        relatedContent.classList.add("active");
        relatedContentTitle.textContent = updatedText; //Assign new text
        gsap.to(relatedContentTitle, {
          color: "#484AD8"
           }, "0")
      },
      onLeaveBack: () => {
        // console.log("relatedContent left view going backward");
        relatedContent.classList.remove("active");
        relatedContentTitle.textContent = currentText; // Restore original text
      
        gsap.to(relatedContentTitle, {
          color: "black"
           }, "0")
      },
    },
  });


}


export function sidePanelOpen(sidePanel) {
  // console.log("sidePanel", sidePanel, "is openening");
  // console.log("gradientLine", gradientLine, "is openening");

  gsap.fromTo(sidePanel, {
    duration: 1,
    x: '100%',
    ease: "power2.out" // review this ease - and ensure globally consistent
  }, {
    x: '0%',
    ease: "power2.out" // review this ease - and ensure globally consistent
  });
  sidePanel.setAttribute('data-side-panel-state', "open");

  //adjust html class
  document.documentElement.classList.add('side-panel-open'); // might be better to set on html element instead 

}

export function sidePanelClose(sideLinks, gradientLine, sidePanel) {
  // console.log("gradientLine", gradientLine, "is idle");
  // console.log("sidePanel", sidePanel, "is closing");

  gsap.to(sidePanel, {
    duration: 1,
    x: '100%',
    ease: "power2.out"
  });
  sidePanel.setAttribute('data-side-panel-state', "closed");

  // remove the gradient line colours on close of panel?
  deActivateGradientLine(gradientLine);
   // ensure all active links are removed
  sideLinks.forEach((item) => {
    item.classList.remove("--active");
  });
  // also ensure the html class is removed
  document.documentElement.classList.remove('side-panel-open');
}



export function removePanelClass() {
  document.documentElement.classList.remove('side-panel-open');
}


//gradietn lines


//mpve this out of home ui - its more a barba or global ui things instead
export function applyGradientLine(gradientLine, linkTarget) {

  // console.log("linkTarget", linkTarget)
  // console.log("gradientLine", gradientLine, "is openening");

  gradientLine.setAttribute('data-gradient-state', linkTarget);

  //review this -! becasue we need to check if the linkTarget is idle or not
  //  if gradientLine.classList.contains("--idle") {

  if (gradientLine.classList.contains("--idle")) {
    gradientLine.classList.remove("--idle");
    gradientLine.classList.add("--active");

  } else {
    gradientLine.classList.add("--active");

  }

}

export function deActivateGradientLine(gradientLine) {
  // to set the gradient line to idle/ default
  gradientLine.classList.add("--idle");
  gradientLine.classList.remove("--active");
  // console.log("gradientLine", gradientLine, "is openening");

}

export function activateGradientLine(gradientLine) {
  // to set the gradient line to idle/ default
  gradientLine.classList.remove("--idle");
  gradientLine.classList.add("--active");
  // console.log("gradientLine", gradientLine, "is openening");

}